// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-button-wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.radio-button-wrapper h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}

.radio-button-item {
  display: flex;
  align-items: center;
  position: relative;
}
.radio-button-item .radio-input {
  position: absolute;
  cursor: pointer;
  margin: 0;
  width: 22px;
  height: 22px;
  top: -2px;
  left: 1px;
}
.radio-button-item .radio-input + .radio-label {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  margin: 0;
  padding-left: 36px;
}
.radio-button-item .radio-input + .radio-label .radio-title {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}
.radio-button-item .radio-input + .radio-label .radio-desc {
  color: var(--radio-desc-text-clr);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-top: 2px;
}
.radio-button-item .radio-input + .radio-label::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  padding: 0;
  text-align: center;
  border-radius: 10px;
  border: 1px solid var(--radio-border);
  background: var(--radio-bg);
  margin-top: 0px;
  border-radius: 100px;
  left: 0;
  position: absolute;
  top: -3px;
}
.radio-button-item .radio-input:checked + .radio-label::before {
  content: "";
  background-color: var(--sdk-global-theme-color);
  border: 1px solid var(--sdk-global-theme-color);
  box-shadow: var(--radio-checked-shadow);
}
.radio-button-item .radio-input:checked:disabled + .radio-label::before {
  opacity: 0.5;
}
.radio-button-item .radio-input:disabled + .radio-label::before {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/radioOptions/radioOptions.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AACI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACR;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AAER;AADQ;EACI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AAGZ;AAFY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAIhB;AAFY;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAIhB;AAFY;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;EACA,OAAA;EACA,kBAAA;EACA,SAAA;AAIhB;AACgB;EACI,WAAA;EACA,+CAAA;EACA,+CAAA;EACA,uCAAA;AACpB;AAIoB;EACI,YAAA;AAFxB;AASgB;EACI,YAAA;AAPpB","sourcesContent":["\n.radio-button-wrapper{\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    h1{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 14px;\n        font-weight: 700;\n        line-height: normal;\n    }\n}\n.radio-button-item{\n    display: flex;\n    align-items: center;\n    position: relative;\n    .radio-input{\n        position: absolute;\n        cursor: pointer;\n        margin: 0;\n        width: 22px;\n        height: 22px;\n        top: -2px;\n        left: 1px;\n        + .radio-label{\n            display: inline-block;\n            vertical-align: middle;\n            cursor: pointer;\n            position: relative;\n            margin: 0;\n            padding-left: 36px;\n            .radio-title{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 500;\n                line-height: normal;\n            }\n            .radio-desc{\n                color: var(--radio-desc-text-clr);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 16px;\n                margin-top: 2px;\n            }\n            &::before{\n                content: '';\n                display: inline-block;\n                vertical-align: middle;\n                width: 22px;\n                height: 22px;\n                padding: 0;\n                text-align: center;\n                border-radius: 10px;\n                border: 1px solid var(--radio-border);\n                background: var(--radio-bg);\n                margin-top: 0px;\n                border-radius: 100px;\n                left: 0;\n                position: absolute;\n                top: -3px;\n            }\n        }\n        &:checked{\n            + .radio-label{\n                &::before{\n                    content: \"\";\n                    background-color: var(--sdk-global-theme-color);\n                    border: 1px solid var(--sdk-global-theme-color);\n                    box-shadow: var(--radio-checked-shadow);\n                }\n            }\n            &:disabled{\n                + .radio-label{\n                    &::before{ \n                        opacity: 0.5;                 \n                    }\n                }\n            }\n        }\n        &:disabled{\n            + .radio-label{\n                &::before{\n                    opacity: 0.5; \n                }\n            }\n        }\n    }   \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
